import React from 'react';
import './wq-integration.css';

// Small building blocks shared by the Web and Mobile integration pages.
// Markup and class names match pages/docs/DirectWebIntegration2.jsx so the
// pages look identical.

export const Note = ({ label = 'Heads up', tone, children }) => (
    <div className={`wq-note${tone === 'critical' ? ' wq-critical' : ''}`}>
        {label ? <div className="wq-note-label">{label}</div> : null}
        {/* Block wrapper: the critical label is inline-flex, so without this
            the text would start on the same line as the label. */}
        <div>{children}</div>
    </div>
);

export const Steps = ({ items }) => (
    <ol className="wq-steps">
        {items.map((item, i) => (
            <li key={i}>{item}</li>
        ))}
    </ol>
);

export const Crumbs = ({ items }) => (
    <div className="wq-crumbs" aria-label="Dashboard path">
        {items.map((item, i) => (
            <React.Fragment key={item}>
                {i > 0 && (
                    <span className="wq-crumb-sep" aria-hidden="true">
                        ›
                    </span>
                )}
                <span className="wq-crumb">{item}</span>
            </React.Fragment>
        ))}
    </div>
);

// columns: ['Value', 'Description'], rows: [['test', 'Sandbox'], ...]
export const WqTable = ({ columns, rows }) => (
    <table className="wq-table">
        <thead>
            <tr>
                {columns.map((c) => (
                    <th key={c}>{c}</th>
                ))}
            </tr>
        </thead>
        <tbody>
            {rows.map((row, i) => (
                <tr key={i}>
                    {row.map((cell, j) => (
                        <td key={j}>{cell}</td>
                    ))}
                </tr>
            ))}
        </tbody>
    </table>
);

// Dashboard screenshot with an optional caption.
export const Figure = ({ src, alt, caption }) => (
    <figure className="wq-figure">
        <img src={src} alt={alt} loading="lazy" />
        {caption && <figcaption>{caption}</figcaption>}
    </figure>
);

// A value the reader can click to copy (e.g. a test card number).
export const CopyValue = ({ value }) => {
    const [copied, setCopied] = React.useState(false);

    const copy = () => {
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(String(value)).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        });
    };

    return (
        <button
            type="button"
            className={`wq-copy-value${copied ? ' copied' : ''}`}
            onClick={copy}
            aria-label={`Copy ${value}`}
        >
            {value}
            <span className="wq-copy-value-hint">{copied ? 'Copied' : 'Copy'}</span>
        </button>
    );
};

export const scrollToSection = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });